import React, {useState} from 'react';
import {v4 as uuid} from 'uuid';

import {useMediaQuery} from '@material-ui/core';
import RenderOrEmpty from '../RenderOrEmpty/RenderOrEmpty';

import SettingsSidebarAction from '../SidebarActions/SettingsSidebarAction';
import HelpAndSupportSidebarAction from '../SidebarActions/HelpAndSupportSidebarAction';

import {USER_ROLES} from '../../constants';
import HamburgerMenuSidebarAction from '../SidebarActions/HamburgerMenuSidebarAction';

import {vertMd} from '../../styles/style';

type SidebarBottomElementsProps = {
  bottomNavLinks?: React.ReactElement[],
  accountInfo: any;
  userRole: string;
  containerClass?: string;
};

function SidebarBottomElements({
  bottomNavLinks = [],
  userRole,
  accountInfo,
  containerClass = '',
}: SidebarBottomElementsProps) {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);

  const matchesSmallVertical = useMediaQuery(`(max-height:${vertMd})`);

  const changeOpenState = (isOpen = false) => {
    setHamburgerOpen(isOpen);
  };

  const elements = [
    ...bottomNavLinks.map((item) => React.cloneElement(item, {
      onClick: () => changeOpenState(false),
      key: uuid(),
    })),
    <RenderOrEmpty
      isShow={userRole !== USER_ROLES.VIEWER
        && userRole !== USER_ROLES.SERVICE_DESK
        && userRole !== USER_ROLES.ORGANIZATION_OPERATOR}
      key={uuid()}
    >
      <SettingsSidebarAction onActionClick={changeOpenState} accountInfo={accountInfo} />
    </RenderOrEmpty>,
    <HelpAndSupportSidebarAction key={uuid()} onActionClick={changeOpenState} />,
  ];

  return (
    <div className={containerClass}>
      {matchesSmallVertical
        ? (
          <HamburgerMenuSidebarAction
            isOpen={hamburgerOpen}
            onClose={() => changeOpenState(false)}
            onClick={() => changeOpenState(!hamburgerOpen)}
          >
            {elements}
          </HamburgerMenuSidebarAction>
        )
        : elements}
    </div>
  );
}

export default SidebarBottomElements;
